<template>
  <v-menu
    :offset-x="$vuetify.breakpoint.smAndUp"
    :offset-y="$vuetify.breakpoint.xsOnly"
    :close-on-content-click="true"
  >
    <template v-slot:activator="{ on: quickAdder }">
      <v-btn text color="success" block v-on="{ ...quickAdder }">
        <v-icon small left>fa-plus</v-icon>
        Ajout rapide
      </v-btn>
    </template>
    <v-list dense>
      <SalesAdder v-if="getIsAdmin === true" list></SalesAdder>
      <v-list-item
        v-if="getIsAdmin === true"
        exact
        :to="{ name: 'RecipeEditor' }"
      >
        <v-list-item-title>
          Recette
        </v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="getIsAdmin === true"
        exact
        :to="{ name: 'ProductCreator' }"
      >
        <v-list-item-title>
          Produit
        </v-list-item-title>
      </v-list-item>
      <v-list-item exact :to="{ name: 'PreparationSlipEditor' }">
        <v-list-item-title>
          Bon de Préparation
        </v-list-item-title>
      </v-list-item>
      <v-list-item exact :to="{ name: 'DeliverySlipCreator' }">
        <v-list-item-title>
          Bon de Commande
        </v-list-item-title>
      </v-list-item>
      <CustomUnitAdder
        v-if="getIsAdmin === true"
        list-item
        @update="$store.dispatch('loadCustomUnits')"
      ></CustomUnitAdder>
    </v-list>
  </v-menu>
</template>

<script>
import { SalesAdder } from "@/modules/Ventes/components";
import { CustomUnitAdder } from "@/modules/CustomUnit/components";
import { mapGetters } from "vuex";
export default {
  name: "QuickAddButton",
  components: {
    SalesAdder,
    CustomUnitAdder
  },
  computed: {
    ...mapGetters(["getStoreId", "getOrganisationId", "getIsAdmin"])
  }
};
</script>

<style></style>
